import {
  WorkflowLinkType,
  WorkflowTemplateVersionStatus,
} from '@prisma/client';
import { GetWorkflowTemplateListExtendsOptions } from './enums';

// Create operation types
export interface TCreateWorkflowTemplateParams {
  name: string;
  externalName: string;
  description?: string;
  key?: string;
}

export interface TCreateWorkflowTemplateVersionParams {
  workflowTemplateId: string;
  version: string;
  versionNote?: string;
  definition?: Record<string, any>;
  status?: WorkflowTemplateVersionStatus;
  starterTemplateVersionId?: string;
}

/** No `version` string, unlike TCreateWorkflowTemplateVersionParams: the server derives the next unused
 * one, because the builder forks on the author's first message with no moment to ask for one. */
export interface TForkWorkflowTemplateVersionParams {
  workflowTemplateId: string;
  sourceWorkflowTemplateVersionId: string;
  versionNote?: string;
}

// Update operation types
/** Client-facing catalog buckets: the TP request modals list only workflows of their own category.
 * The last three have no request modal yet; they exist so seeded workflows can carry a category.
 * Mirrors the backend WORKFLOW_TEMPLATE_CATEGORIES. */
export const WORKFLOW_TEMPLATE_CATEGORIES = [
  'TP_POLICY',
  'TP_BENCHMARK',
  'TP_LOCAL_FILE',
  'TP_MASTER_FILE',
  'TP_CBCR',
] as const;
export type TWorkflowTemplateCategory =
  (typeof WORKFLOW_TEMPLATE_CATEGORIES)[number];

export interface TUpdateWorkflowTemplateParams {
  name?: string;
  description?: string;
  externalName?: string;
  /** Replaces metadata.tags server-side; sibling metadata keys are preserved by the backend merge. */
  tags?: string[];
  /** Replaces metadata.category (same sibling-preserving merge as tags); null clears it. */
  category?: TWorkflowTemplateCategory | null;
}

export interface TUpdateWorkflowTemplateVersionParams {
  version?: string;
  versionNote?: string;
  definition?: any;
  status?: WorkflowTemplateVersionStatus;
}

// List operation types
export interface TGetWorkflowTemplateListParams {
  name?: string;
  createdByUserId?: string;
  companyId?: number;
  extends?: GetWorkflowTemplateListExtendsOptions[];
}

export interface TGetWorkflowTemplateVersionListParams {
  workflowTemplateId?: string;
  version?: string;
  status?: WorkflowTemplateVersionStatus;
}

export type TCreateWorkflowTemplateLinkParams = {
  workflowTemplateId: string;
  entityType?: WorkflowLinkType;
  entityId?: string;
  serviceCompositeId?: string;
};

export type TGetWorkflowTemplateLinkListParams = {
  workflowTemplateId?: string;
  entityType?: WorkflowLinkType;
  entityId?: string;
};
